angular.module('shared').filter('translator', ['$translationService', function ($translationService) {
    return function (inputValue, param1, param2) {
        var result = $translationService.getTranslation(inputValue);
        for (let i = 1; i < arguments.length; i++) {
            if (arguments[i]) {
                result = result.replace('{' + (i - 1) + '}', arguments[i]);
            }
        }

        return result;
    };
}]);